import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useState, useEffect } from 'react';
import { Button, Form, Grid, Checkbox } from 'semantic-ui-react';
import _without from 'lodash/without';
import { SECTION_ITEMS } from './RequestEditModalBody.constants';
import Modal from '../../../../../../modules/foundation/components/Modal';
import { LogRocket } from '../../../../../../services/analytics';
import { BusinessPropType } from '../../../../../../services/proptypes';
import Completion from '../../../Completion';
import { getValidationMessage, logEvent, requestEdit } from '../../RequestEditModal.utils';
import RequestEditModalNote from '../RequestEditModalNote';
import RequesterInformation from '../RequesterInformation';
import './RequestEditModalBody.css';
var defaultProps = {
  onClose: function onClose() {
    return null;
  },
  showRequesterInformation: false
};
export default function RequestEditModalBody(_ref) {
  var business = _ref.business,
    onClose = _ref.onClose,
    handlePublishOpen = _ref.handlePublishOpen,
    showRequesterInformation = _ref.showRequesterInformation;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    requestSubmitted = _useState2[0],
    setRequestSubmitted = _useState2[1];
  var _useState3 = useState({
      name: '',
      email: '',
      phone: '',
      message: '',
      sections: []
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    formData = _useState4[0],
    serFormData = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loading = _useState8[0],
    setLoading = _useState8[1];
  function onFieldChange(e, _ref2) {
    var name = _ref2.name,
      value = _ref2.value;
    serFormData(function (previousFormData) {
      return _objectSpread(_objectSpread({}, previousFormData), {}, _defineProperty({}, name, value));
    });
  }
  function onSectionChange(e, _ref3) {
    var checked = _ref3.checked,
      name = _ref3.name;
    serFormData(function (previousFormData) {
      var previousSections = previousFormData.sections;
      if (checked) {
        return _objectSpread(_objectSpread({}, previousFormData), {
          sections: [].concat(_toConsumableArray(previousSections), [name])
        });
      }
      return _objectSpread(_objectSpread({}, previousFormData), {}, {
        sections: _without(previousSections, name)
      });
    });
  }
  function displayErrorMessage(message) {
    var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    setErrorMessage(message);
    if (clear && message) {
      setTimeout(function () {
        return displayErrorMessage('', false);
      }, 5000);
    }
  }
  function submitRequest() {
    return _submitRequest.apply(this, arguments);
  }
  function _submitRequest() {
    _submitRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var validationMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            validationMessage = getValidationMessage(formData);
            if (validationMessage) {
              _context.next = 17;
              break;
            }
            setLoading(true);
            displayErrorMessage('');
            _context.prev = 4;
            _context.next = 7;
            return requestEdit(business, formData);
          case 7:
            setRequestSubmitted(true);
            _context.next = 14;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            LogRocket.captureError(_context.t0);
            displayErrorMessage('Unknown error requesting edit form. Please try again later.');
          case 14:
            setLoading(false);
            _context.next = 18;
            break;
          case 17:
            displayErrorMessage(validationMessage);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 10]]);
    }));
    return _submitRequest.apply(this, arguments);
  }
  useEffect(function () {
    if (requestSubmitted) {
      logEvent('Request Edit Completion');
    } else {
      logEvent('Request Edit');
    }
  }, [requestSubmitted]);
  if (requestSubmitted) {
    return /*#__PURE__*/React.createElement(Completion, {
      title: "Submission Complete",
      description: "We will reach out to follow up on your edits in the next 24 hours."
    });
  }
  var email = formData.email,
    name = formData.name,
    phone = formData.phone,
    message = formData.message;
  return /*#__PURE__*/React.createElement("div", {
    className: "request-edit-modal-body"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "modal-header"
  }, "Request an edit"), /*#__PURE__*/React.createElement(Form, {
    className: "modal-content modal-body publish-modal-form"
  }, /*#__PURE__*/React.createElement(RequestEditModalNote, {
    onClose: onClose,
    handlePublishOpen: handlePublishOpen
  }), /*#__PURE__*/React.createElement("h3", {
    className: "header-text extra-margin"
  }, "Select the section(s) you would like to change on your website", /*#__PURE__*/React.createElement("span", {
    className: "blue-color"
  }, "*")), /*#__PURE__*/React.createElement(Grid, {
    doubling: true,
    className: "section-selection-grid",
    columns: 3
  }, SECTION_ITEMS.map(function (section) {
    return /*#__PURE__*/React.createElement(Grid.Column, {
      key: section,
      textAlign: "left"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      name: section,
      onChange: onSectionChange,
      label: section
    }));
  })), /*#__PURE__*/React.createElement("h3", {
    className: "header-text extra-margin"
  }, "Please describe the edit request(s) in more detail", /*#__PURE__*/React.createElement("span", {
    className: "blue-color"
  }, "*")), /*#__PURE__*/React.createElement(Form.TextArea, {
    id: "request-text-area",
    name: "message",
    placeholder: "Edit Request",
    onChange: onFieldChange,
    rows: 5,
    value: message
  }), /*#__PURE__*/React.createElement(RequesterInformation, {
    show: showRequesterInformation,
    name: name,
    email: email,
    phone: phone,
    onFieldChange: onFieldChange
  }), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "error-message"
  }, errorMessage), /*#__PURE__*/React.createElement("div", {
    className: "centered-content extra-margin"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "back-button-request-edit",
    className: "back-edit-request-button blue-color body-text",
    onClick: onClose,
    content: "Back",
    disabled: loading
  }), /*#__PURE__*/React.createElement(Button, {
    id: "submit-edit-request-button",
    className: "submit-edit-request-button body-text green-background-color",
    onClick: submitRequest,
    content: "Submit",
    loading: loading,
    disabled: loading
  }))));
}
RequestEditModalBody.defaultProps = defaultProps;